import { Injectable } from '@angular/core';
import { ViewerDetails } from '../models/viewer-details';
import { ScannedDetails } from '../models/scanned-details';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppConfigService } from '../core/config/app-config.service';
import { map, catchError } from 'rxjs/operators'
import { ViewerSearch } from '../models/viewer-search';
import { SortableColumn } from '../core/sort/sortable-column';

@Injectable({
  providedIn: 'root'
})


export class ViewerService {
  protected apiUrl = AppConfigService.settings.AppConfig.API_ENDPOINT
  constructor(private http: HttpClient) { }
  sortGrouping:string;


  getDetailsByRTN(rtn: string, regObjId: string, isSecondaryRTN: Boolean): Observable<any[]> {

    const url = `${this.apiUrl}viewer/GetDetailsByRTN/${rtn}/${regObjId}/${isSecondaryRTN}`;
    return this.http.get(url).
      pipe(
        map((data: any[]) => {
          return data;
        }), catchError(error => {

          return throwError('Something went wrong!')
        })
      )
  }


  getElectronicallySubmittedDetails(rtn: string, sortColumn: string, sortDirection: string, pageNumber: number, pageSize: number): Observable<any[]> {

    const url = `${this.apiUrl}viewer/GetElectronicallyFiles/${rtn}/${sortColumn}/${sortDirection}/${pageNumber}/${pageSize}`;
    return this.http.get(url).
      pipe(
        map((data: any[]) => {

          return data;
        }), catchError(error => {

          return throwError('Something went wrong!')
        })
      )
  }


  getScannedDetails(rtn: string, sortColumn: string, sortDirection: string, pageNumber: number, pageSize: number): Observable<any[]> {

    const url = `${this.apiUrl}viewer/GetScannedFiles/${rtn}/${sortColumn}/${sortDirection}/${pageNumber}/${pageSize}`;
    return this.http.get(url).
      pipe(
        map((data: any[]) => {

          return data;
        }), catchError(error => {

          return throwError('Something went wrong!')
        })
      )
  }

  getApplicationMetadata(): Observable<any> {
    const url = `${this.apiUrl}Metadata/GetMetadata`;
    return this.http.get<any>(url).pipe(map(r => r));
  }

  getZipCodeBasedOnCity(city: string): Observable<any> {
    
    const url = `${this.apiUrl}Metadata/GetZipCodeByCity/${city}`;
    return this.http.get(url).
      pipe(
        map((data: any[]) => {

          return data;
        }), catchError(error => {

          return throwError('Something went wrong!')
        })
      )
  }

  getRTN(rtn: string): Observable<any> {
    debugger;
    const url = `${this.apiUrl}Viewer/GetListOfRTN/${rtn}`;
    return this.http.get<any>(url).pipe(map(r => r));
  }

  getChemical(chemical: string): Observable<any> {
    debugger;
    const url = `${this.apiUrl}Viewer/GetListOfChemical/${chemical}`;
    return this.http.get<any>(url).pipe(map(r => r));
  }

  getAllViewer(viewerSearch: ViewerSearch, pageNumber: number, pageSize: number, sortColumn: SortableColumn): Observable<any> {
    let QueryStr = this.buildQuery(viewerSearch);
    //QueryStr += "email=" + this.user.UserEmail + "&";
    QueryStr += "pageNumber=" + pageNumber + "&";
    QueryStr += "pageSize=" + pageSize + "&";
    if (sortColumn != undefined)
    {
      var sortStringArray = sortColumn.name.split(',');
      for (let i = 0; i < sortStringArray.length; i++) {

        if(i==0)
        {
            this.sortGrouping = sortStringArray[i] + " " + sortColumn.direction
        }
        else{
            this.sortGrouping = this.sortGrouping + "," + (sortStringArray[i] + " " + sortColumn.direction);
        }
             
        }
      QueryStr += `&orderBy=` + this.sortGrouping;
    }
    const url = `${this.apiUrl}viewer/GetViewerBySearchFields/?` + QueryStr;
    return this.http.get<any>(url).pipe(map(r => r));
  }


  getExportExcelViewer(viewerSearch: ViewerSearch): Observable<any> {
    let QueryStr = this.buildQuery(viewerSearch);
    const url = `${this.apiUrl}viewer/ExportExcel/?` + QueryStr;
    return this.http.get<any>(url).pipe(map(r => r));
  }

  private buildQuery(viewerSearch: ViewerSearch) {
    let QueryStr = '';

    if (viewerSearch.siteType != undefined && viewerSearch.siteType != null)
      QueryStr += "siteType=" + viewerSearch.siteType + "&";
    if (viewerSearch.townName != null)
      QueryStr += "townName=" + viewerSearch.townName + "&";
    if (viewerSearch.rtn != null)
      QueryStr += "rtn=" + viewerSearch.rtn + "&";
    if (viewerSearch.address != null)
      QueryStr += "address=" + viewerSearch.address + "&";
    if (viewerSearch.regulatoryStatus != null)
      QueryStr += "regulatoryStatus=" + viewerSearch.regulatoryStatus + "&";
    if (viewerSearch.lsp != null)
      QueryStr += "lsp=" + viewerSearch.lsp + "&";
    if (viewerSearch.siteName != null)
      QueryStr += "siteName=" + viewerSearch.siteName + "&";
    if (viewerSearch.zipCode != null)
      QueryStr += "zipCode=" + viewerSearch.zipCode + "&";
    if (viewerSearch.chemical != null)
      QueryStr += "chemical=" + viewerSearch.chemical + "&";

    return QueryStr;
  }


}

